// period
export const periodHour = 1;
export const periodMinute = 15;
// limit
export const maxLimit = 10000000;
export const hourMinLimit = 0;
export const minuteMinLimit = 0;
